import axios from "axios";
import { OUTLET_ORGANISATIONS, typeOutlets } from "../pages/Home/HomeSlice";

export const VERSION = 3;

const _axios = ({ outlet }: { outlet: typeOutlets }) =>
  axios.create({
    baseURL: process.env.REACT_APP_EXABLOOM_SERVICE_URL,
    headers: {
      version: process.env.REACT_APP_EXABLOOM_SERVICE_VERSION ?? VERSION,
      organisationuuid: OUTLET_ORGANISATIONS[outlet].organisationUuid,
      [`${process.env.REACT_APP_EXABLOOM_KEY}`]:
        process.env.REACT_APP_HAVEFUN_ONLINE_BOOKING_SECRET ?? "",
    },
  });

export default _axios;
